/**
 * @flow
 * @relayHash c70420a36d81b843c0400b3f5e71707e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddReminderForEventInput = {|
  email: string,
  eventId: string,
  language: string,
  participant?: ?string,
|};
export type AddReminderForEventMutationVariables = {|
  input: AddReminderForEventInput
|};
export type AddReminderForEventMutationResponse = {|
  +addReminderForEvent: ?{|
    +status: ?string
  |}
|};
export type AddReminderForEventMutation = {|
  variables: AddReminderForEventMutationVariables,
  response: AddReminderForEventMutationResponse,
|};
*/


/*
mutation AddReminderForEventMutation(
  $input: AddReminderForEventInput!
) {
  addReminderForEvent(input: $input) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddReminderForEventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addReminderForEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddReminderForEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddReminderForEventMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddReminderForEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddReminderForEventMutation",
    "id": null,
    "text": "mutation AddReminderForEventMutation(\n  $input: AddReminderForEventInput!\n) {\n  addReminderForEvent(input: $input) {\n    status\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e58ffe3ab4dfd3877ad702bb1c1bf189';

module.exports = node;
